
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightFloat as ObiLightFloatElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-float.js';
 
 
 

 
 export const ObiLightFloat = createComponent({
   react: React,
   tagName: 'obi-light-float',
   elementClass: ObiLightFloatElement,
   events: {
     
   }
  });
 
 